module.exports = __webpack_public_path__ + "img/13.b56774d2.webp";